(function() {
    'use strict';
    angular
        .module('quantixApp')
        .factory('EconomicIndicatorService', EconomicIndicatorService);
    EconomicIndicatorService.$inject = ['$http', '$q'];
    
    function EconomicIndicatorService($http, $q) {

        var getAllCategories = function() {
            return $http.get('api/aifbenchmark/getallcategories', {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var getEcoIndicatorData = function(selectedCategory) {
            return $http.post('api/aifbenchmark/getecoindicatordata', selectedCategory, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var filterGraph = function(filterCriteria) {
            return $http.post('api/aifbenchmark/filtergraph', filterCriteria, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var compareGraph = function(filterCriteria) {
            return $http.post('api/aifbenchmark/comparegraph', filterCriteria, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var getAllSubCategories = function() {
            return $http.get('api/aifbenchmark/getallsubcategories', {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var checkDenomination = function(filterCriteria) {
            return $http.post('api/aifbenchmark/checkdenomination', filterCriteria, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var getCategoryFrequency = function(filterCriteria) {
             return $http.get('api/aifbenchmark/getFrequency', {
                responseType : 'application/json',
                headers : {
                       'Content-Type' : 'application/json'
                }});
        }
        

		return {
            getAllCategories: getAllCategories,
            getEcoIndicatorData: getEcoIndicatorData,
            filterGraph: filterGraph,
            getAllSubCategories: getAllSubCategories,
            compareGraph: compareGraph,
            checkDenomination: checkDenomination,
            getCategoryFrequency: getCategoryFrequency
        }

    }
})();